// import { useRouter } from "../hooks/useRouter";
import { useEffect, useState } from "react";
import { createServiceInicisBill, getInicisData } from "src/service/pay";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import {
  ICreateServiceBillReq,
  IGetInicisDataRes,
} from "src/service/types/pay.type";
import { insertInicisModule } from "src/utils/pay/insertInicisModule";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
const ExceptPay = () => {
  const { t } = useTranslation();
  const { lang } = useRouter();
  // const { routeTo } = useRouter();
  const [inicisData, setInicisData] = useState<IGetInicisDataRes>();
  const [currency, setCurrency] = useState<string>("WON");
  const [userInfo] = useRecoilState(userInfoAtom);
  // 결제 카드 교체 정보
  const payApply = async ({
    orderID,
    subscriptionID,
  }: {
    orderID: string;
    subscriptionID: string;
  }) => {
    // if (isCheckPay) {
    try {
      const serviceRequest: ICreateServiceBillReq = {
        billType: "PROMOTION",
        currency: "WON",
        licenseCount: 0,
        orderID: orderID,
        payCompany: "INICIS",
        payTerm: "year",
        serviceBillUid: "",
        subscriptionID: subscriptionID,
        userCode: userInfo.userCode,
      };

      const result = await createServiceInicisBill({ ...serviceRequest });

      if (result) {
        alert("결제완료");
      }
    } catch (error: any) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage);
      }
    }
    // this.commonStore.setLoading(false);
    // }
  };
  const requestPay = async () => {
    // e.preventDefault();
    console.log("click requestPay");
    // const result = await getInicisData({ price: 10 });
    // setInicisData(result);
    if (inicisData) {
      await payApply({ orderID: inicisData.oid, subscriptionID: "Inicis" });
    }
  };
  const billPrint_msg = t(
    "siteManagement.paymentHistory.bill.detail.includeVat"
  );
  useEffect(() => {
    insertInicisModule();
    async function init() {
      const inicisData = await getInicisData({ price: 2000000 });
      // const inicisData = await getInicisData({ price: 10 });
      if (inicisData) setInicisData(inicisData);
    }
    init();
  }, []);
  // const returnUrl = window.location.origin +
  // "/eco-cloud/wapi/cloud/pay/service/returnUrl/" +
  // payData?.oid +
  // "/" +
  // window.sessionStorage.getItem("product")
  const onClickPurchase = async () => {
    // @ts-expect-error
    const INIStdPay = window?.INIStdPay;
    INIStdPay.pay("inicisForm");
  };
  return (
    // <div className="mainBody mg m-auto">
    //   <ReactInicis
    //     payData={{
    //       returnUrl: "",
    //       productName: "서대문구청 차세대업무관리시스템 암복호화 연동툴 구매",
    //       buyerName: inicisData?.buyerName ?? "",
    //       buyerTel: "010-0000-0000",
    //       buyerEmail: inicisData?.buyerEmail ?? "",
    //       // productPrice:3000000,
    //       mid: inicisData?.mid ?? "",
    //       // payStatus:inicisData?.payStatus,
    //       // telStatus:"",
    //       // returnUrl:"",
    //       // closeUrl:"",

    //       signature: inicisData?.signature ?? "",
    //       mKey: inicisData?.mKey ?? "",
    //       timestamp: inicisData?.timestamp ?? "",
    //       oid: inicisData?.oid ?? "",
    //       price: "3000000",
    //     }}
    //     currency={currency}
    //     goodName={"암복호화 연동툴"}
    //   >
    //     <button
    //       type="button"
    //       className="btn btn-green btn-40 width w-100p pd py-10"
    //       // onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    //       //   e.preventDefault();
    //       // }}
    //       // onMouseDown={requestPay}
    //       onClick={requestPay}
    //     >
    //       {/* <i className="icon_minus_green inline-block vertical-middle" /> */}
    //       <span className="inline-block vertical-middle mg ml-2">
    //         <img
    //           className="mg mr-10"
    //           style={{ width: "16px", height: "12px" }}
    //           src="/resources/images/card.png"
    //         />
    //         {t("common.card")}
    //       </span>
    //     </button>
    //   </ReactInicis>
    // </div>
    <>
      {/* 이니시스 PC 결제 폼 */}
      <form
        className="inicisForm"
        id="inicisForm"
        name="inicisForm"
        method="POST"
        style={{ display: "none" }}
      >
        <input name="version" readOnly value="1.0" />
        <input name="mid" readOnly value={inicisData?.mid} />
        <input
          name="goodname"
          readOnly
          required={true}
          value={"강동구도시관리공단 2024년 사이버위기대응(해킹메일) 모의훈련"}
        />
        <input name="oid" readOnly value={inicisData?.oid} />
        <input name="price" readOnly value={inicisData?.price} />
        <input name="currency" readOnly value={currency} />
        <input name="buyername" readOnly value={inicisData?.buyerName} />
        <input name="buyertel" readOnly value="010-0000-0000" />
        <input name="buyeremail" readOnly value={inicisData?.buyerEmail} />
        <input name="timestamp" readOnly value={inicisData?.timestamp} />
        <input name="signature" readOnly value={inicisData?.signature} />
        <input
          name="returnUrl"
          readOnly
          value={
            window.location.origin +
            "/eco-cloud/wapi/cloud/pay/service/returnUrl/" +
            // "/eco-cloud/wapi/cloud/pay/service/returnUrl/custom/" +
            inicisData?.oid +
            "/" +
            // "except"
            window.sessionStorage.getItem("product")
          }
        />
        <input name="mKey" readOnly value={inicisData?.mKey} />
        <input name="gopaymethod" readOnly value="Card" />
        <input name="acceptmethod" readOnly value="below1000:billauth(card)" />
        <input name="billPrint_msg" readOnly value={billPrint_msg} />
        <input name="languageView" readOnly value={lang} />
        <input name="charset" readOnly value="UTF-8" />
        <input name="merchantData" readOnly value="" />
        <input name="tax" readOnly value="0" />
        <input name="taxfree" readOnly value="0" />
        <input
          type="hidden"
          readOnly
          name="closeUrl"
          value={window.location.href}
        />
      </form>

      {/* <span onClick={}> */}
      <button
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          e.preventDefault();
          onClickPurchase();
        }}
        onMouseDown={requestPay}
        className="btn btn-green btn-40 width w-100p mg mt-20 pd py-10"
        style={{
          width: "auto",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "200px",
        }}
        // onMouseDown={() => {
        //   requestPay();
        // }}
        // disabled={!confirmPolicy}
      >
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            className="mg mr-10"
            style={{ width: "16px", height: "12px" }}
            src="/resources/images/card.png"
          />
          {t("common.card")}
        </span>
      </button>
      {/* </span> */}
    </>
  );
};

export default ExceptPay;
